export default {
  kpiMonthList: [],
  mainChart: [],
  grpDetail: {},
  grpList: [],
  kpiList: [],
  userList: [],
  dsbYn: [],
  three: [],
  threeKpi: [],
  threeData: [],
  chartData: [],
  chartKpi: [],
  grpData: {},
  grpCol: [],
  kpiCol: [],
  userCol: [],
  createView: false,
  detailView: false,
};
